import { useEffect } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import LoadingOverlay from "../../components/LoadingOverlay"
import { useAuthRequest } from "../../api/hooks/useAuthRequest"
import { useGetUserInfo } from "../../api/hooks/useGetUserInfo"
import { ROUTES_PATHS } from "../../utils/constants"
import { RootState } from "../../store/store"
import { setToken } from "../../store/slices/auth"
import { EUserIdentificationLevel } from "../../types/identification"

const IdentificationPreCheck = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()  
  const token = useSelector((state: RootState) => state.auth.token)

  const {
    data: authData,
    isError: isAuthError,
    refetch: fetchAuthData,
  } = useAuthRequest(token, false)

  const {
    data: userInfo,
    isError: isUserInfoError,
    refetch: fetchUserInfo,
  } = useGetUserInfo(false)

  // Auth request
  useEffect(() => {
    if (token && !authData) {
      fetchAuthData()
    }
  }, [token, authData, fetchAuthData])

  // Get user info
  useEffect(() => {
    if (authData?.token) {
      dispatch(setToken(authData.token))
      setTimeout(() => {
        fetchUserInfo()
      }, 0)
    }
  }, [authData?.token, dispatch, fetchUserInfo])

  // check fields and redirect
  useEffect(() => {
    if (userInfo) {
      const isPassportNeeded = userInfo.identificationLevel === EUserIdentificationLevel.Anonymous

      if (isPassportNeeded) {
        navigate(`/${ROUTES_PATHS.topUpMbankAccount}/identification/uprid`)
      } else {
        navigate(`/${ROUTES_PATHS.error}`)
      }
    }
  }, [userInfo, navigate, searchParams])

  // Handle errors
  useEffect(() => {
    if (isAuthError || isUserInfoError || authData?.result === "Error") {
      navigate(`/${ROUTES_PATHS.error}`)
    }
  }, [isAuthError, isUserInfoError, navigate, authData?.result])

  return (
    <LoadingOverlay
      disableOpacity
      title="Проверка данных"
      text={
        <>
          Проверяем ваши данные... <br />
          Дождитесь окончания процесса
        </>
      }
    />
  )
}

export default IdentificationPreCheck

